import React from 'react'
import { useEffect, useState } from 'react'
import Tabs from '../../../../Components/Tabs'
import GetIcon from '../../../../utils/Icon'
import { Link, useNavigate } from 'react-router-dom'
import { NavLink } from 'react-router-dom'
import Tab1 from './Tab1'
import Table from './Table'
import printerimg from "../../../../assets/print.png"
import ApiResponseBox from '../../../../Components/ApiResponseBox'
import BulkUpload from './BulkUpload'
import { useGetPaymentTermsQuery } from '../../../../store/api/paymenttermapi'
import { useGetCurrencyListQuery } from '../../../../store/api/companyapi'
import { useGetPriceListQuery } from "../../../../store/api/pricelistapi";
import { useGetTaxCategoryListQuery } from "../../../../store/api/taxcategoryapi";
import { useGetTermsandConditionQuery } from "../../../../store/api/termsandconditionapi";
import { useGetCostCenterListQuery } from "../../../../store/api/costcenterapi";
import { useGetProjectListQuery } from "../../../../store/api/projectapi";
import { useGetSalesInvoiceDocMutation, useUpdateSalesInvoiceMutation } from '../../../../store/api/salesinvoice'
import { useGetCustomerDetailsMutation } from '../../../../store/api/customer'
import Attachment from '../../../../utils/Attachment'
import PrintModal from '../../../../Core/Print/PrintModal'

function Salesform({ sales_invoice_id }) {
    const [getCustomerDetails, { data: customerData, isLoading: isCustomerLoading, isError: isCustomerError }] = useGetCustomerDetailsMutation();
    const [DeliveryNote, SetDeliveryNote] = useState("");
    const [formdata, setFormData] = useState({
        sales_invoice_id: "",
        customer: "",
        mobile_no: "",
        delivery_address: "",
        payment_due_date: "",
    });
    const [getSalesInvoiceDoc, { data: invoiceData, isLoading, isSuccess, isError, error: errorget }] = useGetSalesInvoiceDocMutation();
    const [termsandcondition, settermsandcondition] = useState([]);
    const [taxandchanges, settaxandchanges] = useState('');
    const [paymentterm, setpaymentterm] = useState([]);
    const [currency, setcurrency] = useState('');
    const [pricel, setpricel] = useState('');
    const [project, setproject] = useState('');
    const [cost_center, setcost_center] = useState('');
    const [selectedItem, setSelectedItem] = useState(null);
    const [rows, setRows] = useState([]);
    const [item_Rows, setitem_Rows] = useState([]);
    const [docstatus, setdocstatus] = useState();
    useEffect(() => {
        if (sales_invoice_id) {
            fetchSalesInvoice(sales_invoice_id);
        }
    }, [sales_invoice_id]);
    const fetchSalesInvoice = async (invoiceId) => {
        try {
            const response = await getSalesInvoiceDoc({
                doctype: "Sales Invoice",
                name: invoiceId,
            }).unwrap();

            const message = response?.docs?.[0];

            if (message) {
                setFormData({
                    sales_invoice_id: message.name || "",
                    customer: message.customer || "",
                    mobile_no: message.contact_mobile || "",
                    delivery_address: message.shipping_address
                        ?.replace(/<br\s*\/?>|\n/g, ' ')
                        .replace(/\s+/g, ' ')
                        .trim() || "",
                    payment_due_date: message.due_date || "",
                    due_date: message?.payment_schedule?.[0]?.due_date || "",
                });
                settermsandcondition(message.terms ? [message.terms] : []);
                settaxandchanges(message.taxes_and_charges || "");
                setpaymentterm(message.payment_schedule || []);
                setcurrency(message.currency || "");
                setpricel(message.selling_price_list || "");
                setproject(message.project || "");
                setcost_center(message.items?.[0]?.cost_center || "");
                setitem_Rows(message.items || []);
                setdocstatus(message.docstatus)
                console.log("Invoice loaded & states updated:", message);
            } else {
                console.error("No invoice data found");
            }
        } catch (err) {
            console.error("Failed to fetch invoice:", err);
        }
    };
    const handleFetchCustomer = async () => {
        try {
            const payload = {
                customer_name: formdata.customer,
            };

            const response = await getCustomerDetails(payload).unwrap();
            console.log("Customer Details:", response.result);
            const result = response.result;
            const phoneMatch = result.primary_address?.match(/Phone:\s?([0-9]+)/i);
            const extractedPhone = phoneMatch ? phoneMatch[1] : "";

            setFormData((prev) => ({
                ...prev,
                mobile_no: extractedPhone,
            }));
        } catch (error) {
            console.error("Fetch error:", error);
        }
    };

    useEffect(() => {
        if (formdata.customer) {
            handleFetchCustomer();
        }
    }, [formdata.customer]);

    const nvg = useNavigate()
    const [item, setItem] = useState(false)
    const [buttonData, setButtonData] = useState(false)
    // const [rows, setRows] = useState([{
    //     item_code: "",
    //     item: {},
    //     required_by: "",
    //     quantity: 1,
    //     uom: "",
    //     rate: "0",
    //     amount: "0",
    // }]);
    const [tab, settab] = useState(1)
    const [ptype, setptype] = useState("Error ")
    const [showPrintModal, setShowPrintModal] = useState(false);
    const [showpopup, setShowpopup] = useState(false);
    const [showError, setShowError] = useState(false);
    const [error, setError] = useState('');
    const { data: p_term } = useGetPaymentTermsQuery();
    const { data: pricelist } = useGetPriceListQuery({ filters: JSON.stringify({ selling: 1 }) });
    const { data: currencylist } = useGetCurrencyListQuery();
    const { data: taxandchangeslist } = useGetTaxCategoryListQuery();
    const { data: tandc } = useGetTermsandConditionQuery();
    const { data: costcenterlist } = useGetCostCenterListQuery();
    const { data: projectlist } = useGetProjectListQuery();


    const [fieldErrors, setFieldErrors] = useState({
        customer: false,
        dueDate: false,
        billing_address: false,
        shipping_address: false,
        billingType: false,
        order_type: false,
        items: false
    });
    const [po_response, setpo_response] = useState("");
    const [selected_item_data, setselected_item_data] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const handleNavigate = (path) => {
        nvg(path);
        setShowDropdown(false);
    };
    const [tab1Data, setTab1Data] = useState({});
    const [tab1CustomerData, setTab1CustomerData] = useState({});
    const [orderNo, setorderNo] = useState('');
    const [activityboll, setactivityboll] = useState(false)
    const totalQty = item_Rows.reduce((sum, item) => sum + Number(item.qty || 0), 0);
    return (
        <>
            <Tabs />
            <div className="d-flex justify-content-between " style={{ background: "#fcfdfe", height: '40px', padding: '0px 5px' }}>
                <div className="d-flex align-items-center customizewidth">
                    <p className="m-0 breadcrumb-item">Outbound</p>
                    <p className="m-0 "> <GetIcon iconName="MdOutlineKeyboardArrowRight" size={13} /> </p>
                    <p className="m-0 breadcrumb-item" style={{ cursor: 'pointer' }} onClick={() => nvg('/outbound/outbound/sales-invoice')}>Sales Invoice  </p>
                    <p className="m-0 ">  <GetIcon iconName="MdOutlineKeyboardArrowRight" size={13} />  </p>
                    <a href="javascript:void(0);" className="pagetitle d-flex align-items-center mainpage" style={{ borderBottom: "0px solid", textWrap: "nowrap", gap: '5px', color: "#270B79", fontSize: '' }} >
                        View Sales Invoice
                        <button
                            className={` ${buttonData
                                ? 'rounded-pill newdesign123'
                                : 'rounded-pill newdesign2343'
                                }`}
                        >
                            {docstatus == 1 ? 'Submitted' : item ? 'Draft' : 'Draft'}
                        </button>
                    </a>
                </div>
    
                <div className="d-flex align-items-center justify-content-end customizewidth" style={{ gap: '5px' }} >
                    {item && buttonData && (
                        <div style={{ position: 'relative', display: 'inline-block', height: '28px' }}>
                            <NavLink
                                onClick={() => setShowDropdown(prev => !prev)}
                                className="createbutton m-0"
                                style={{ color: "#391F84", borderRadius: "3px", cursor: 'pointer', height: '28px' }}
                            >
                                Create
                                <span className="iconbox ps-2">
                                    <GetIcon iconName="IoMdArrowDropdown" size={14} />
                                </span>
                            </NavLink>

                            {showDropdown && (
                                <div className="create-dropdown" >
                                    <div

                                        className="menu-item"
                                        style={{ height: '28px' }}>
                                        Pick List
                                    </div>
                                    <div onClick={() => handleNavigate('/delivery')} className="menu-item">Delivery Note</div>
                                    <div onClick={() => handleNavigate('/sales')} className="menu-item">Sales Invoice</div>
                                    <div onClick={() => handleNavigate('/material')} className="menu-item">Material Request</div>
                                    <div onClick={() => handleNavigate('/request')} className="menu-item">Request Raw Materials</div>
                                </div>
                            )}
                        </div>
                    )}
 <p className="p-0 m-0">
                                                                <img src={printerimg} 
                                                                onClick={() => setShowPrintModal(true)} 
                                                                 className="px-2" style={{width:'35px',cursor:'pointer'}} alt="404" />
                                                            </p>


                </div>

            </div>
            <div className="d-flex flex-column" style={{ width: "100%", backgroundColor: "#fff", flexGrow: '1' }}>
                <div className="col-12 p-0" style={{ backgroundColor: '#eff4f9' }}>
                    <div className="d-flex justify-content-between align-items-end ">
                        <ul
                            className="nav nav-tabs mb-0"
                            style={{ color: "white", border: "none" }}
                        >
                            <li className="nav-item-tab-custom d-flex pb-0 align-items-end border-radius-top-corner">
                                <a
                                    className={tab == 1 ? "nav-link active-tab-custom text-white border-radius-top-corner" : "nav-link nav-link-tab-custom bg-white border-radius-top-corner"}
                                    onClick={() => { settab(1) }}
                                    href="javascript:void(0);"
                                >
                                    General Details
                                    {tab == 1
                                        ? <GetIcon iconName="MdKeyboardArrowDown" size={15} />
                                        : <GetIcon iconName="MdKeyboardArrowRight" size={15} />}
                                </a>
                            </li>


                        </ul>
                          <Attachment doctype="Sales Invoice"  docname={sales_invoice_id}  /> 
                    </div>
                </div>
                <div className="row d-flex justify-content-between" style={{ marginTop: '14px', flexGrow: '1' }}>
                    {/* className="row sidebarbox m-0" style={{ padding: "8px", borderRadius: "5px",  height: "70vh",overflowY: "scroll"}} */}
                    <div className="col-3 sidebarbox" style={{ visibility: tab == 1 ? "visible" : 'hidden', height: tab == 1 ? "auto" : '0px', overflow: tab == 1 ? "" : 'hidden' }}>
                        <Tab1 formdata={formdata} setTab1Data={setTab1Data} setTab1CustomerData={setTab1CustomerData} orderNo={orderNo} fieldErrors={fieldErrors} activityboll={activityboll}

                            pTerms={{ paymentterm: paymentterm, setpaymentterm: setpaymentterm, list: p_term?.data }} price={{ list: pricelist?.data, setvalue: setpricel, value: pricel }}
                            currency={{ list: currencylist?.data, setvalue: setcurrency, value: currency }}
                            taxandchanges={{ list: taxandchangeslist?.data, setvalue: settaxandchanges, value: taxandchanges }}
                            termandcondition={{ termsandcondition, settermsandcondition, list: tandc?.data }}
                            cost_center={{ list: costcenterlist?.data, setvalue: setcost_center, value: cost_center }}
                            project={{ list: projectlist?.data, setvalue: setproject, value: project }}
                        />
                    </div>
                    {tab == 1 ? <div className="col-9 d-flex flex-column mt-2" style={{ visibility: tab == 1 ? "visible" : 'hidden', height: tab == 1 ? "auto" : '0px', minHeight: tab == 1 ? '440px' : '0' }}>

                        {/* <div className="col-9" style={{ visibility: tab == 1 ? "visible" : 'hidden', height: tab == 1 ? "auto" : '0px', overflow: tab == 1 ? "" : 'hidden' }}> */}
                        <div className="d-flex pb-2" style={{ gap: '5px' }}>
                            <p className="NoOfLine">No. of lines - <span style={{ color: '#2563EB' }}> {item_Rows.length}</span></p>
                            <p className="TotalQty">Total Quantity -  <span style={{ color: '#16A34A' }}> {totalQty}</span></p>
                            <p className="TotalQty">Total Shipping -  <span style={{ color: '#16A34A' }}> {totalQty}</span></p>

                        </div>
                        <div className="tableLabel">
                            <div style={{ width: '98.5%', borderBottom: '1px solid #caced3', marginBottom: '6px' }}></div>
                            <p style={{ color: "#1E1E1E", fontWeight: '500', fontSize: '15px', marginBottom: '4px' }}>
                                Item Details
                            </p>
                        </div>
                        <Table
                            row={{ Rows: item_Rows, setRows: setitem_Rows, selectedItem }}

                        />

                        <div className=" mt-auto pb-1" style={{ display: po_response.data ? '' : 'none' }}>

                            <div className="row">
                                <div className="col-3">
                                    <p className="TotalQtywithoutBg">Ordered Quantity -  <span className="px-2" style={{ color: '#EC642A' }}> {selected_item_data.reduce((sum, item) => sum + Number(item.quantity), 0)}</span></p>
                                </div>
                                <div className="col-3">
                                    <p className="NoOfLinewithoutBg">Taxable Value - <span className="px-2" style={{ color: '#FF5969' }}> {selected_item_data.reduce((sum, item) => sum + Number(item.quantity * item.item.buying_price), 0)}</span></p>
                                </div>
                                <div className="col-3">
                                    <p className="NoOfLinewithoutBg">Tax - <span className="px-2" style={{ color: '#2563EB' }}> {selected_item_data.reduce((sum, item) => sum + Number(item.quantity * item.item.buying_price), 0)}</span></p>
                                </div>
                                <div className="col-3">
                                    <p className="NoOfLinewithoutBg">Total Value - <span className="px-2" style={{ color: '#16A34A' }}> {selected_item_data.reduce((sum, item) => sum + Number(item.quantity * item.item.buying_price), 0)}</span></p>
                                </div>
                            </div>
                        </div>
                    </div>
                        : ''}

                </div>
            </div>



            {showPrintModal && (
                                        <PrintModal 
                                            onClose={() => setShowPrintModal(false)}
                                            documentId={formdata.sales_invoice_id}
                                             doctype="Sales Invoice"
                                            title="Print Sales Invoice"
                                        />
                                    )}

            <ApiResponseBox
                poptype={ptype}
                show={showError}
                errorMessage={error}
                onClose={() => setShowError(false)}
            />
            <BulkUpload
                show={showpopup}
                onClose={() => setShowpopup(false)}
                rows={rows}
                setRows={setRows}
                setselected_item_data={setselected_item_data}
            />

        </>
    )
}

export default Salesform
